import { PaymentType } from '../state/types'

// Si el medio de pago se ofrece para elegir: no archivado ni deshabilitado. keepIds son los que ya tiene elegidos
// lo que se está editando (ej. el medio de pago de la venta), que se siguen mostrando aunque no se ofrezcan.
export const isSelectablePaymentType = (paymentType: PaymentType, ...keepIds: (string | undefined)[]) =>
    keepIds.includes(paymentType.id) || (!paymentType.archived && !paymentType.disabled)
